import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { MapPin, CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export default function VerifyEmailPage() {
  const { token } = useParams();
  const [status, setStatus] = useState("checking");
  const [message, setMessage] = useState("");

  useEffect(() => {
    axios.get(`${API}/auth/verify-email/${token}`)
      .then(() => setStatus("success"))
      .catch((e) => {
        setStatus("error");
        setMessage(e?.response?.data?.detail || "Nie udało się zweryfikować adresu e-mail.");
      });
  }, [token]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex flex-col">
      <header className="p-4">
        <Link to="/" className="flex items-center gap-2 w-fit">
          <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
            <MapPin className="w-5 h-5 text-white" />
          </div>
          <span className="font-bold text-xl tracking-tight">lokalnie.pro</span>
        </Link>
      </header>

      <main className="flex-1 flex items-center justify-center px-4 py-8">
        <Card className="shadow-xl max-w-md w-full">
          <CardContent className="pt-10 pb-10 text-center space-y-4">
            {status === "checking" && (
              <>
                <Loader2 className="w-10 h-10 text-slate-400 mx-auto animate-spin" />
                <p className="text-slate-600">Weryfikacja adresu e-mail...</p>
              </>
            )}
            {status === "success" && (
              <>
                <CheckCircle2 className="w-12 h-12 text-emerald-500 mx-auto" />
                <h1 className="text-xl font-bold text-slate-900">Email zweryfikowany</h1>
                <Link to="/dashboard"><Button className="bg-amber-500 hover:bg-amber-600">Przejdź do panelu</Button></Link>
              </>
            )}
            {status === "error" && (
              <>
                <XCircle className="w-12 h-12 text-red-500 mx-auto" />
                <h1 className="text-xl font-bold text-slate-900">Nie udało się zweryfikować</h1>
                <p className="text-sm text-slate-600">{message}</p>
                <Link to="/dashboard"><Button variant="outline">Przejdź do panelu</Button></Link>
              </>
            )}
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
